/**
 * Interpret error responses from the Client Verification service.
 *
 * Kept out of clientVerificationService.js deliberately: this is a pure
 * function, and living next to the axios client meant tests could not use the
 * real implementation without pulling axios's ESM build through Jest.
 *
 * The backend returns { error, detail, error_code, attempts_remaining,
 * retry_after_seconds } inside FastAPI's `detail` envelope.
 *
 * @param {object} error An axios error.
 * @returns {{status: ?number, message: string, errorCode: ?string,
 *            attemptsRemaining: ?number, retryAfterSeconds: ?number,
 *            auditEvent: ?object}}
 */
export const parseVerificationError = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object') {
    return {
      status: error.response.status,
      message: detail.error || 'Something went wrong.',
      errorCode: detail.error_code || null,
      attemptsRemaining: typeof detail.attempts_remaining === 'number'
        ? detail.attempts_remaining
        : null,
      retryAfterSeconds: typeof detail.retry_after_seconds === 'number'
        ? detail.retry_after_seconds
        : null,
      // A failed verification is the most common history update, and it arrives
      // as a 4xx rather than a success response - so the audit row the API
      // wrote rides along here.
      auditEvent: detail.audit_event || null
    };
  }
  return {
    status: error?.response?.status || null,
    message: (typeof detail === 'string' && detail) || error?.message || 'Something went wrong.',
    errorCode: null,
    attemptsRemaining: null,
    retryAfterSeconds: null,
    auditEvent: null
  };
};

export default parseVerificationError;
